import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, UserPlus, Phone, Euro } from 'lucide-react';
import { useGetPromoterStatsQuery } from '../../store/promoterApi';
import StatCard from '../shared/StatCard';

const PromotersStats: React.FC = () => {
  const { t } = useTranslation();
  const { data: stats, isLoading } = useGetPromoterStatsQuery();

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="bg-white p-5 rounded-2xl shadow-sm ring-1 ring-gray-900/[0.04] animate-pulse">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-3"></div>
                <div className="h-8 bg-gray-200 rounded w-1/2"></div>
              </div>
              <div className="w-11 h-11 bg-gray-200 rounded-xl"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  const displayStats = [
    {
      title: t('promoters.stats.total'),
      value: stats?.total ?? 0,
      formatValue: (v: number) => Math.round(v).toLocaleString(),
      icon: Users,
      color: 'bg-gradient-to-r from-purple-500 to-purple-600',
      to: '/promoters',
    },
    {
      title: t('promoters.stats.invited'),
      value: stats?.invited ?? 0,
      formatValue: (v: number) => Math.round(v).toLocaleString(),
      icon: UserPlus,
      color: 'bg-gradient-to-r from-yellow-500 to-orange-500',
      to: '/promoters',
    },
    {
      title: t('promoters.stats.readyForCall'),
      value: stats?.readyForCall ?? 0,
      formatValue: (v: number) => Math.round(v).toLocaleString(),
      icon: Phone,
      color: 'bg-gradient-to-r from-green-500 to-emerald-600',
      to: '/promoters',
    },
    {
      title: t('promoters.stats.totalRewards'),
      value: stats?.totalRewards ?? 0,
      formatValue: (v: number) => `${Math.round(v).toLocaleString()}€`,
      icon: Euro,
      color: 'bg-gradient-to-r from-orange-500 to-red-500',
      to: '/rewards',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {displayStats.map((stat, index) => (
        <StatCard
          key={index}
          index={index}
          title={stat.title}
          value={stat.value}
          formatValue={stat.formatValue}
          icon={stat.icon}
          color={stat.color}
          to={stat.to}
        />
      ))}
    </div>
  );
};

export default PromotersStats;
